<section class="page-container memberProfile">


    <div class="container">

        <div class="row mb-4">
            <div class="col-12">
                <div class="breadcrumbTrail">
                    <a [routerLink]="['/public/member-directory']">Member Directory</a>
                    <span class="breadcrumbLevel"><i class="fa-regular fa-angle-right"></i></span>
                    <!-- member directory filtered to this industry -->
                    <!-- <a href="member-directory.html">Agriculture</a> -->
                </div>
            </div>
        </div>

        <div class="profileHeader mb-5">
            <div class="row">
                <div class="col-md-9">
                    <div class="d-flex align-items-center justify-content-start">
                        <div class="industryIconWrap">
                            <span class="industryIcon">
                                <i class="fa-regular fa-star"></i>
                            </span>
                        </div>
                        <h1 class="profileName">{{member.memberName}}</h1>
                    </div>
                </div>
                <div *ngIf="hasLetterOfIntroPerk && !isMyCompany" class="col-md-3 mt-3 mt-md-0">
                    <button type="button" class="btn btn-secondary m-100 introduceBtn" (click)="introduceYourself()"><i class="fa-solid fa-handshake"></i> Introduce Yourself</button>
                </div>
            </div>
        </div>

        <div class="row gx-5">
            <div class="col-md-8">
                <div class="profileSection">
                    <div class="sectionHeader">
                        <span class="sectionName">
                            About
                        </span>
                    </div>
                    <div class="sectionContent">
                         <div *ngIf="member.logoUrl != null" class="memberLogo">
                            <img src="{{member.logoUrl}}" alt="member logo" />
                        </div> 
                         <div [innerHTML]="member.memberDescription"></div>
                    </div>
                </div>
                <div class="profileSection" *ngIf="canViewMemberContent && member.canSeeLiaison">
                    <div class="sectionHeader">
                        <span class="sectionName">
                            Liaison Contact
                        </span>
                    </div>
                    <div class="sectionContent">
                        <div class="memberContact">
                            <div class="contactLine">
                                <div class="contactIconWrap">
                                    <span class="contactIcon">
                                        <i class="fa-solid fa-user"></i>
                                    </span>
                                </div>
                                <div class="contactInfo">
                                    {{liaison.fullName}}
                                </div>
                            </div>
                            <div class="contactLine">
                                <div class="contactIconWrap">
                                    <span class="contactIcon">
                                        <i class="fa-solid fa-phone"></i>
                                    </span>
                                </div>
                                <div class="contactInfo">
                                    <a href="tel:{{liaison.phoneNumberNonDisplay}}">{{liaison.phoneNumber}}</a>
                                </div>
                            </div>


                            <div class="contactLine">
                                <div class="contactIconWrap">
                                    <span class="contactIcon">
                                        <i class="fa-solid fa-envelope"></i>
                                    </span>
                                </div>
                                <div class="contactInfo">
                                    <a class="text-decoration-underline" href="mailto:{{liaison.emailAddress}}"
                                        target="_blank">{{liaison.emailAddress}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profileSection">
                    <div class="sectionHeader">
                        <span class="sectionName">
                            Website
                        </span>
                    </div>
                    <div class="sectionContent">
                        <div class="memberContact">
                            <div class="contactLine">
                                <div class="contactIconWrap">
                                    <span class="contactIcon">
                                        <i class="fa-solid fa-globe"></i>
                                    </span>
                                </div>
                                <div class="contactInfo">
                                    <a class="text-decoration-underline" href="{{(member.website.startsWith('http')) ? '' : 'https://'}}{{member.website}}"
                                        target="_blank">{{member.website}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">



                <div class="mapCanvas" #map>
                </div>
                <div class="mt-4">
                    <div class="profileSection">
                        <div class="sectionHeader">
                            <span class="sectionName">
                                Locations
                            </span>
                        </div>
                        <div class="sectionContent">
                            <div class="memberContact">
                                <div *ngFor="let location of locations" class="contactLine">
                                    <div (click)="zoomToIconAddress(location)" class="contactIconWrap">
                                        <span  class="contactIcon">
                                            <i class="fa-solid fa-location-dot"></i>
                                        </span>
                                    </div>
                                    <div class="contactInfo">
                                        <div class="fw-bold">{{location.locationName}}</div>
                                        {{location.locationStreet}}<br>
                                        {{location.locationCity}}, {{location.locationState}} {{location.locationZip}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div>

    </div>

</section>